import './_sass/main.sass'

import smoothScroll from 'smooth-scroll'
import Vue from 'vue'
import VueRouter from 'vue-router'

import Background from './_vue/Background.vue'

new Vue({
  el: '#bg',
  components: { Background }
})

// VUE ROUTER

Vue.use(VueRouter);

var App = Vue.extend({})

var router = new VueRouter()

router.map({
    '/': {
      component: require('./_vue/Shell.vue'),
      subRoutes: {
        '/photos': {
          component: require('./_vue/Photos.vue')
        }
      }
    }
})

router.start(App, 'body')

// INIT

// SmoothScroll
var initSmoothScroll = function() {
  smoothScroll.init({
    selector: '[data-scroll]',
    speed: 500,
    easing: 'easeInOutCubic',
    offset: 0,
    updateURL: false
  });
}

document.addEventListener('DOMContentLoaded', initSmoothScroll);


/** WEBPACK FOOTER **
 ** ./public/_src/index.js
 **/